import React, { FormEventHandler, FocusEventHandler } from 'react';

import TextField from '../TextField/TextField';
import { Field } from '../../../declarations/widget-ums';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';
import { NAME_PATTERN } from '../../../constants/REGEXP_PATTERNS';
import Patronymic from '../Patronymic/Patronymic';

export interface FIOProps {
  name: Field<string>;
  surname: Field<string>;
  patronymic: Field<string>;
  isPatronymicAbsent: Field<boolean>;
  nameFields: string[];
}

interface Props {
  name?: Field<string>;
  surname?: Field<string>;
  patronymic?: Field<string>;
  isPatronymicAbsent: Field<boolean>;
  inMarriage?: boolean;
  nameFields: string[];
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
}

function FIO({
  nameFields,
  onChange,
  onBlur,
  inMarriage = false,
  isPatronymicAbsent,
  ...fields
}: Props): JSX.Element {
  return (
    <div className="PguFormGrid__row">
      {nameFields.map((field) => {
        const props = {
          key: field,
          className: 'PguFormGrid_col PguFormGrid__col_3',
          inputProps: {
            name: field,
            maxLength: 200,
            ...fields[field],
            onChange,
            onBlur,
          },
          maskOptions: {
            regex: NAME_PATTERN.FOR_INPUT_MASK,
            placeholder: '',
            showMaskOnFocus: false,
            showMaskOnHover: false,
          },
        };

        if (['patronymic', 'changedPatronimic'].includes(field)) {
          return (
            <Patronymic
              {...props}
              className={''}
              inMarriage={inMarriage}
              isPatronymicAbsent={isPatronymicAbsent}
            />
          );
        }
        return (
          <TextField
            {...props}
            placeholder={getPersonPlaceholder(field, inMarriage)}
          />
        );
      })}
    </div>
  );
}

export default FIO;
